import { Observable } from 'rxjs';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { MyComponent } from './components/my-component';
import { MyProvider } from './providers/my-provider';


export class MyModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: MyModule,
      providers: [ MyProvider ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    // declare all components that your module uses
    MyComponent
  ],
  exports: [
    // export the component(s) that you want others to be able to use
    MyComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
